import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, Label, CartesianGrid } from 'recharts';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

/**
 * PC_Pc_04 getPerformanceData gets importd from api.js file
 */

import { getDomainData, getEvaluationData, getFeedbackData, getFormPopUp, getPerformanceData, getRatingData } from '../service/api';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../components/css/Dashboard-styles.css';
import { PieChart, Pie, Sector, Cell } from 'recharts';

// export default function PerformanceData(props) {
//     /**
//      * PC_Pc_02
//      * The data , role , domains, filtervalue , filterShow state variable is created for storing the response data
//      */

//     const [data, setData] = useState([]);

//     const [role, setRole] = useState(encryptStorage.getItem('role'));

//     const [domains, setDomains] = useState([]);

//     const [filterValue, setFilterValue] = useState('');

//     const [filterShow, setFilterShow] = useState(false);

//     const filterObj = {
//         domain: '',
//         year: '',
//     };

//     const [filterData, setFilterData] = useState(filterObj);

//     const [filterPressed, setFilterPressed] = useState(false);

//     /**
//      * PC_Pc_03
//      * Use Efffect method is called to get role from session and store it
//      */

//     useEffect(() => {

//         setRole(props.role);

//         fetchApi();
//     }, []);

//     /**
//      * PC_Pc_06
//      * The fetchApi function in the useEffects gets invoked which inturn call the getPerformanceData() function with respective parameters
//      */

//     const fetchApi = async (dataFilter = '') => {
//         let resp;

//         if (dataFilter.domain || dataFilter.year) {
//             resp = await getPerformanceData(dataFilter, props.role);
//         } else {
//             resp = await getPerformanceData('', props.role);
//         }

//         if (resp?.data?.ResponseData.length) setData(resp.data.ResponseData);
//         else setData([]);

//         const domainDrop = await getDomainData();

//         if (domainDrop.data.ResponseData.length > 0) setDomains(domainDrop.data.ResponseData);
//     };

//     const filterClicked = () => {
//         fetchApi(filterData);

//         setFilterPressed(true);
//     };

//     /**
//      * PC_Pc_10
//      * The response data gets stored in the data variable and passed to the LineChart
//      */

//     return (
//         <>
//             <div className="d-flex justify-content-between" style={{ marginBottom: '-10px' }}>
//                 <h1 className="tt-bold font-15 p-3">{role == 'Hr Manager' ? "Organization's Performance" : 'Team Performance'}</h1>
//                 <div className="dropdown m-2 ">
//                     <button
//                         className={`btn ${role == 'Hr Manager' ? 'dashboard-filter-btn' : null}  font-12 medium-text`}
//                         type="button"
//                         onClick={() => {
//                             setFilterShow(!filterShow);
//                         }}
//                     >
//                         {filterData.domain && filterPressed && filterData.domain != filterValue
//                             ? `${filterValue}`
//                             : filterData.domain && filterPressed
//                             ? `${filterData.domain}`
//                             : role == 'Hr Manager'
//                             ? `ALL`
//                             : null}
//                         <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
//                     </button>

//                     {filterShow ? (
//                         <div
//                             className="dropdown-menu dashboard-filter-dropdown px-3 py-3"
//                             style={{ display: 'block' }}
//                             onBlur={(event) => {
//                                 if (!event.currentTarget.contains(event.relatedTarget)) {
//                                     setFilterShow(false);
//                                 }
//                             }}
//                         >
//                             <div className="d-flex justify-content-between">
//                                 <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
//                                 <button
//                                     onClick={() => {
//                                         setFilterShow(!filterShow);
//                                     }}
//                                     className="btn p-0"
//                                 >
//                                     <img src="/Images/Path 38820.svg" />
//                                 </button>
//                             </div>
//                             {role == 'Hr Manager' ? (
//                                 <>
//                                     <label className="medium-text font-12 d-flex mb-1">Domain</label>
//                                     <select
//                                         value={filterData.domain}
//                                         onChange={(e) => {
//                                             setFilterData((filterData) => ({
//                                                 ...filterData,
//                                                 [e.target.name]: e.target.value,
//                                             }));
//                                         }}
//                                         className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
//                                         name="domain"
//                                     >
//                                         <option disabled selected value="">
//                                             Select Domain
//                                         </option>
//                                         {domains.map((domain) => {
//                                             return <option value={domain}>{domain}</option>;
//                                         })}
//                                     </select>
//                                 </>
//                             ) : null}
//                             <label className="medium-text font-12 d-flex mb-1">Year</label>
//                             <DatePicker
//                                 selected={filterData.year}
//                                 onChange={(e) => {
//                                     setFilterData((filterData) => ({
//                                         ...filterData,

//                                         ['year']: e,
//                                     }));
//                                 }}
//                                 name="year"
//                                 showYearPicker
//                                 value={filterData.year}
//                                 className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
//                                 dateFormat="yyyy"
//                                 placeholderText="Select Year"
//                             />
//                             <div className="d-flex justify-content-end mt-3">
//                                 <button
//                                     onClick={(e) => {
//                                         setFilterData(filterObj);
//                                         fetchApi();
//                                         setFilterPressed(false);
//                                         setFilterShow(!filterShow);
//                                     }}
//                                     className="btn hive-btn-secondary me-3"
//                                 >
//                                     Clear
//                                 </button>
//                                 <button
//                                     autoFocus
//                                     onClick={(e) => {
//                                         filterClicked(e);
//                                         setFilterValue(filterData.domain);
//                                         setFilterShow(!filterShow);
//                                     }}
//                                     type="button"
//                                     className="btn hive-btn-primary dashboard-btn-filter"
//                                 >
//                                     Apply
//                                 </button>
//                             </div>
//                         </div>
//                     ) : null}
//                 </div>
//             </div>
//             <div className="text-center position-relative">
//                 <span className="yaxis-style">Percentage</span>
//                 <span className="xaxis-style">Evaluation Period</span>
//                 <LineChart width={510} height={300} data={data}>
//                     <XAxis
//                         dataKey="name"
//                         padding={{ left: 30, right: 30 }}
//                         style={{
//                             fontSize: '12px',
//                             fontFamily: 'SF Pro Regular',
//                             color: '#959595',
//                         }}
//                     ></XAxis>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <YAxis
//                         style={{
//                             fontSize: '12px',
//                             fontFamily: 'SF Pro Regular',
//                         }}
//                     ></YAxis>

//                     <Line dataKey="percentageu" stroke="#F29B10" activeDot={{ r: 8 }} isAnimationActive={false} />
//                     {/* <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
//                 </LineChart>
//             </div>
//         </>
//     );
// }

export default function PerformanceData(props) {
    const [data, setData] = useState([]);

    const [role, setRole] = useState(encryptStorage.getItem('role'));

    const [domains, setDomains] = useState([]);

    const [filterValue, setFilterValue] = useState('');

    const [filterShow, setFilterShow] = useState(false);
    const [period, setPeriod] = useState();
    const [filterRatingData, setFilterRatingData] = useState();

    const filterObj = {
        domain: '',
        dates: '',
    };

    const [filterData, setFilterData] = useState(filterObj);

    const [filterPressed, setFilterPressed] = useState(false);
    const [evaluationPeriod, setEvaluationPeriod] = useState([]);
    const navigate = useNavigate();

    /**
     * PC_Pc_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {

        setRole(props.role);

        fetchApi();
    }, []);
    const fetchApi = async (filterData = {}) => {
       
        let resp;

        if (filterData.dates || filterData.domain) {
            resp = await getRatingData(filterData, props.role);
        } else {
            resp = await getRatingData('', props.role);
        }
        if (resp?.data?.ResponseData?.length) setData(resp.data.ResponseData);

        let resps;

        resps = await getFeedbackData('', props.role);

        if (resps?.data?.ResponseData?.length > 2) {
            setPeriod(resps.data.ResponseData[2]);
        }

        const evalPeriod = await getEvaluationData();

        if (evalPeriod?.data?.ResponseData) setEvaluationPeriod(evalPeriod.data.ResponseData);
        const domainDrop = await getDomainData();

        if (domainDrop?.data?.ResponseData?.length > 0) setDomains(domainDrop.data.ResponseData);
    };
    const filterClicked = () => {
        fetchApi(filterData);

        setFilterPressed(true);
    };
    const handleClick = (e) => {
        navigate('/TeamDirectory?dashboard=true', {
            state: {
                rating: e.name.split(' ')[1],
                domain: filterData?.domain || '',
                start_date: filterData?.dates?.split('||')[0] || '',
                end_date: filterData?.dates?.split('||')[1] || '',
            },
        });
    };
    // const COLORS = ['#30C681', '#FFC107', '#E05379'];
    const COLORS = [
        '#008000', // Green
        '#90EE90', // Light Green
        '#FFA500', // Orange
        '#FFD700', // Light Orange
        '#FF0000', // Red
        '#FFC0CB',
    ];

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="ps-3">
                    <h1 className="tt-bold font-15 pt-3 mb-1">{role == 'Hr Manager' ? `Organization's Rating` : 'Team Rating'}</h1>
                    <p className="medium-text font-9 dash-grey">{`Ratings of the employee `}</p>
                </div>
                <div className="dropdown m-2 " style={{ 'z-index': '1' }}>
                    <button
                        className={`btn ${role == 'Hr Manager' ? 'dashboard-filter-btn' : null}  font-12 medium-text`}
                        type="button"
                        id="dropdownMenuButton126"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {filterData.domain && filterPressed && filterData.domain != filterValue
                            ? `${filterValue}`
                            : filterData.domain && filterPressed
                                ? `${filterData.domain}`
                                : role == 'Hr Manager'
                                    ? `ALL`
                                    : null}
                        <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                    </button>
                    <div className="dropdown-menu dashboard-filter-dropdown px-3 py-3">
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                <button className="btn p-0">
                                    <img src="/Images/Path 38820.svg" />
                                </button>
                            </div>

                            <div className="col-md-12">
                                {role == 'Hr Manager' ? (
                                    <>
                                        <label className="medium-text font-12 d-flex mb-1">Domain</label>
                                        <select
                                            value={filterData.domain}
                                            onChange={(e) => {
                                                setFilterData((filterData) => ({
                                                    ...filterData,
                                                    [e.target.name]: e.target.value,
                                                }));
                                            }}
                                            className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                            name="domain"
                                        >
                                            <option selected value="">
                                                Select
                                            </option>
                                            {domains.map((domain) => {
                                                return <option value={domain}>{domain}</option>;
                                            })}
                                        </select>
                                    </>
                                ) : null}
                            </div>

                            <div className="col-md-12">
                                <h5 className="font-12 bold-text mt-3">Evaluation Period</h5>
                                <select
                                    value={filterData.dates}
                                    onChange={(e) => {
                                        setFilterData((filterData) => ({
                                            ...filterData,
                                            [e.target.name]: e.target.value,
                                        }));
                                    }}
                                    className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                    name="dates"
                                >
                                    <option selected disabled value="">
                                        Evaluation Periods
                                    </option>
                                    {evaluationPeriod.map((evaluation) => {
                                        const valStart = moment(evaluation.start_date).format('YYYY-MM-DD');
                                        const valEnd = moment(evaluation.end_date).format('YYYY-MM-DD');

                                        return (
                                            <option value={valStart + '||' + valEnd}>
                                                {moment(evaluation.start_date).format('DD MMM') +
                                                    '-' +
                                                    moment(evaluation.end_date).format('DD MMM,YYYY')}
                                            </option>
                                        );
                                    })}
                                </select>
                                {/* <div className="col-md-6">
                  <label className="medium-text font-12 d-flex mb-1">From</label>
                  <input type="date" className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1" placeholder="Select Domain" />
                </div>
                <div className="col-md-6">
                  <label className="medium-text font-12 d-flex mb-1">To</label>
                  <input type="date" className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1" placeholder="Select Domain" />
                </div> */}
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                                <a
                                    onClick={() => {
                                        setFilterData(filterObj);
                                        fetchApi(filterObj);
                                        setFilterPressed(false);
                                    }}
                                    className="btn hive-btn-secondary me-3"
                                >
                                    Clear
                                </a>
                                <button
                                    onClick={(e) => {
                                        filterClicked(e);
                                        setFilterValue(filterData.domain);
                                    }}
                                    className="btn hive-btn-primary dashboard-btn-filter"
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-center d-flex mt-4">
                <div className="col-md-7">
                    <PieChart width={300} height={300} style={{ 'margin-top': '-120px', left: '-25px' }} className="ms-2">
                        <Pie
                            data={data}
                            cx={120}
                            cy={200}
                            innerRadius={65}
                            outerRadius={80}
                            fill="#8884d8"
                            // paddingAngle={5}
                            dataKey="value"
                            onClick={(e) => {
                                handleClick(e);
                            }}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip payload={[]} />
                    </PieChart>
                </div>
                <div className="col-md-3 ms-3 align-self-center text-start">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className='team-rating-box-1 mb-3'></div>
                            <p className="semibold-text font-11 ms-3 text-start ">
                                {/* { <span>
        <img src="/Images/Green-Flag.svg" className="dashboard-custom-flagsize me-1" />
    </span> } */}
                                Group A+
                            </p>
                        </div>

                        <p className="ms-2 font-18 tt-bold text-end">{data[0]?.value}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className='team-rating-box-2 mb-3'></div>
                            <p className="semibold-text font-11 ms-3 text-start">
                                {/* <span>
        <img src="/Images/Yellow-Flag.svg" className="dashboard-custom-flagsize me-1" />
    </span> */}
                                Group A-
                            </p>
                        </div>
                        <p className="ms-2 font-18 tt-bold text-end">{data[1]?.value}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className='team-rating-box-3 mb-3'></div>
                            <p className="semibold-text font-11 ms-3 text-start">
                                {/* <span>
        <img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-1" />
    </span> */}
                                Group B+
                            </p>
                        </div>
                        <p className="ms-2 font-18 tt-bold text-end">{data[2]?.value}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className='team-rating-box-4 mb-3'></div>
                            <p className="semibold-text font-11 ms-3 text-start">
                                {/* <span>
        <img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-1" />
    </span> */}
                                Group B-
                            </p>
                        </div>
                        <p className="ms-2 font-18 tt-bold text-end">{data[3]?.value}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className='team-rating-box-5 mb-3'></div>
                            <p className="semibold-text font-11 ms-3 text-start">
                                {/* <span>
        <img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-1" />
    </span> */}
                                Group C+
                            </p>
                        </div>
                        <p className="ms-2 font-18 tt-bold text-end">{data[4]?.value}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className='team-rating-box-6 mb-3'></div>
                            <p className="semibold-text font-11 ms-3 text-start">
                                {/* <span>
        <img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-1" />
    </span> */}
                                Group C-
                            </p>
                        </div>
                        <p className="ms-2 font-18 tt-bold text-end">{data[5]?.value}</p>
                    </div>

                    {/* <div> <p className="semibold-text font-11"><span><img src="/Images/yellow-flag.svg" className="dashboard-custom-flagsize me-2" /></span>yellow </p></div><span className="ms-2 font-18 tt-bold">{flagData.yellow}</span> */}
                    {/* <div> <p className="semibold-text font-11"><span><img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-2" /></span>red </p> </div><span className="ms-2 font-18 tt-bold">{flagData.red}</span> */}
                </div>
            </div>
        </>
    );
}
